import { render, staticRenderFns } from "./VCharges.vue?vue&type=template&id=359ad50e&"
import script from "./VCharges.vue?vue&type=script&lang=js&"
export * from "./VCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports